import { useNode } from "@craftjs/core";
import React from "react";
import { useTranslation } from "react-i18next";

import SettingsTitleWrapper from "@/components/editor/shared/settings-title-wrapper";
import { Input } from "@/components/shared/forms";
import { isValidUrl } from "@/utils/url-utils";

export default function Settings() {
  const { actions, props } = useNode((node) => ({ props: node.data.props }));
  const { t } = useTranslation();
  const [iframeSrc, setIframeSrc] = React.useState(props.src);
  const [urlError, setUrlError] = React.useState<string | null>(null);
  return (
    <SettingsTitleWrapper title="iFrame">
      <Input
        label={t("preference-panel.url")}
        name="Iframe URL"
        placeholder="https://hopin.com/widgets/schedule/my-event-slug?headerEnabled=false&filtersEnabled=true"
        value={iframeSrc}
        onChange={(event) => {
          const currentValue = event.currentTarget.value;
          setIframeSrc(currentValue);
          if (isValidUrl(currentValue)) {
            actions.setProp((props) => (props.src = currentValue));
            setUrlError(null);
          } else {
            setUrlError(t("preference-panel.invalid-iframe-src-msg"));
          }
        }}
        error={urlError ?? undefined}
        className="mb-4"
      />
      <Input
        label={t("preference-panel.height")}
        name="iframe height"
        placeholder="300"
        value={props.height}
        onChange={(event) => {
          actions.setProp(
            (props) => (props.height = event.currentTarget.value)
          );
        }}
        className="mb-4"
      />
      <Input
        label={t("preference-panel.width")}
        name="iframe width"
        placeholder="300"
        value={props.width}
        onChange={(event) => {
          actions.setProp((props) => (props.width = event.currentTarget.value));
        }}
        className="mb-4"
      />
    </SettingsTitleWrapper>
  );
}
